// extracted by mini-css-extract-plugin
export var grid = "_r-0";
export var span1 = "_r-2";
export var span10 = "_r-b";
export var span10L = "_r-z";
export var span10M = "_r-n";
export var span10Xl = "_r-1b";
export var span11 = "_r-c";
export var span11L = "_r-10";
export var span11M = "_r-o";
export var span11Xl = "_r-1c";
export var span12 = "_r-d";
export var span12L = "_r-11";
export var span12M = "_r-p";
export var span12Xl = "_r-1d";
export var span1L = "_r-q";
export var span1M = "_r-e";
export var span1Xl = "_r-12";
export var span2 = "_r-3";
export var span2L = "_r-r";
export var span2M = "_r-f";
export var span2Xl = "_r-13";
export var span3 = "_r-4";
export var span3L = "_r-s";
export var span3M = "_r-g";
export var span3Xl = "_r-14";
export var span4 = "_r-5";
export var span4L = "_r-t";
export var span4M = "_r-h";
export var span4Xl = "_r-15";
export var span5 = "_r-6";
export var span5L = "_r-u";
export var span5M = "_r-i";
export var span5Xl = "_r-16";
export var span6 = "_r-7";
export var span6L = "_r-v";
export var span6M = "_r-j";
export var span6Xl = "_r-17";
export var span7 = "_r-8";
export var span7L = "_r-w";
export var span7M = "_r-k";
export var span7Xl = "_r-18";
export var span8 = "_r-9";
export var span8L = "_r-x";
export var span8M = "_r-l";
export var span8Xl = "_r-19";
export var span9 = "_r-a";
export var span9L = "_r-y";
export var span9M = "_r-m";
export var span9Xl = "_r-1a";
export var stretch = "_r-1";